import React from "react";
import { MailIcon, Phone } from "lucide-react";
import Sidebar from "../components/Sidebar";

function NoSubscription() {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Sidebar />
      <div className="flex-grow ml-64 p-8">
        <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="p-8">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-yellow-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                No Active Subscription
              </h2>
              <p className="text-gray-600 mb-6">
                You currently don't have an active subscription to access the bot settings.
                Please contact our support team to activate your subscription.
              </p>
            </div>

            <div className="space-y-4">
              <a
                href="mailto:krasi@skylinepropertylets.co.uk"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors w-full"
              >
                <MailIcon className="w-5 h-5" />
                Contact via Email
              </a>
              
              <a
                href="https://wa.me/447756668272"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors w-full"
              >
                <Phone className="w-5 h-5" />
                Contact via WhatsApp
              </a>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Available Subscription Plans:
              </h3>
              <div className="space-y-4">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-medium text-gray-800">Ads Auto Renew</h4>
                  <p className="text-gray-600 text-sm">
                    Automatically renew your SpareRoom listings
                  </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-medium text-gray-800">Email Automation</h4>
                  <p className="text-gray-600 text-sm">
                    Automated email responses to SpareRoom enquiries
                  </p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <h4 className="font-medium text-gray-800">Premium Package</h4>
                  <p className="text-gray-600 text-sm">
                    Full access to both Auto Renew and Email Automation features
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoSubscription;